import { createTheme } from '@mui/material/styles';
import { tokens, FONT_FAMILY } from './tokens';

/**
 * Advisor-experience MUI theme.
 *
 * Overrides are deliberately conservative: admin pages (Customer Management,
 * Review Queue, Analytics, Utilization) render inside this theme too, so we only
 * change palette/typography plus a few low-risk component defaults.
 */
const theme = createTheme({
  palette: {
    primary: { main: tokens.navy },
    secondary: { main: tokens.sage },
    success: { main: tokens.green },
    warning: { main: tokens.gold },
    error: { main: tokens.clay },
    background: {
      default: tokens.bg,
      paper: tokens.card,
    },
    divider: tokens.border,
    text: {
      primary: tokens.text,
      secondary: tokens.textSec,
      disabled: tokens.textMut,
    },
  },
  shape: {
    borderRadius: 10,
  },
  typography: {
    fontFamily: FONT_FAMILY,
    button: {
      textTransform: 'none',
      fontWeight: 600,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          boxShadow: 'none',
          '&:hover': { boxShadow: 'none' },
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
    MuiPaper: {
      styleOverrides: {
        outlined: {
          borderColor: tokens.border,
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        head: {
          fontWeight: 700,
          color: tokens.textSec,
        },
      },
    },
  },
});

export { tokens, FONT_FAMILY };
export default theme;
